module.exports = __webpack_public_path__ + "static/media/default.722cd0a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/carMaintenance/index/default.png
// module id = 1192
// module chunks = 0